var $ea59e6cf97c93c32$exports = {};
$ea59e6cf97c93c32$exports = {
    "collapse": `Zbali\u{165}`,
    "expand": `Rozbali\u{165}`
};


export {$ea59e6cf97c93c32$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
